export function setAppName(appName: string): void {
  window.newrelic?.setCustomAttribute("appName", appName);
}

export function setCustomAttribute(key: string, value: string | number | boolean): void {
  window.newrelic?.setCustomAttribute(key, value);
}

export function noticeError(error: Error, attributes?: Record<string, unknown>): void {
  window.newrelic?.noticeError(error, attributes);
}
